import { FC, Fragment } from "react";
import React from "react";
import { ChangeNames } from "../../clients/FirebaseClient/types";
import { useFormModel } from "../core/FormModelHelpes";
import { BoxedInputWithIconAndOptionalSwitch } from "../core/BoxedInputWithIconAndOptionalSwitch";
import { GasIcon } from "../core/icons/Icons";
import { NumberInput } from "../core/NumberField";
import { Colors } from "../../styles";
import { useStyles } from "../../useStyles";
import { createStyles, makeStyles, InputLabel } from "@material-ui/core";
import { FormControlLabel } from "../core/FormControlLabel";
import { Checkbox } from "../core/Checkbox";

const textStyles = makeStyles(() =>
    createStyles({
        pText: {
            color: Colors.anthracite,
            fontStretch: "normal",
            fontFamily: "innogyWEB",
            fontSize: 22,
            fontWeight: 300,
            fontStyle: "normal",
            lineHeight: 1.27,
            letterSpacing: "normal",
        },
    }),
);

export const IncreaseCurrentGasDemandForm: FC = () => {
    const classes = useStyles();
    const classes2 = textStyles();
    const { values, setValues } = useFormModel<ChangeNames.INCREASE_CURRENT_GAS_DEMAND>();
    return (
        <Fragment>
            <BoxedInputWithIconAndOptionalSwitch
                icon={<GasIcon />}
                content={
                    <Fragment>
                        <p className={classes.label} style={{ marginBottom: 8 }}>
                            Gasnennwärmeleistung
                        </p>
                        <p className={classes2.pText} style={{ marginTop: 0, marginBottom: 24 }}>
                            Geben Sie die bestehende Gasnennwärmeleistung an. Diese Leistung
                            erhalten Sie ggf. von Ihrem Heizungsinstallateur/Architekten.
                        </p>
                        <InputLabel className={classes.labledTextfieldLabel}>
                            Summe der Gasnennwärmeleistung
                        </InputLabel>
                        <NumberInput
                            className={classes.textField}
                            fixedDecimalScale={false}
                            allowLeadingZeros={false}
                            decimalScale={values.increaseCurrentGasDemand.value.precision}
                            isNumericString={false}
                            allowNegative={false}
                            thousandSeparator="."
                            decimalSeparator=","
                            adornment={values.increaseCurrentGasDemand.value.unit}
                            value={values.increaseCurrentGasDemand.value.amount.num || ""}
                            placeholder="0"
                            onValueChange={v =>
                                setValues(values => {
                                    values.increaseCurrentGasDemand.value.amount.num =
                                        v.floatValue || null;
                                })
                            }
                            error={values.increaseCurrentGasDemand.error !== null}
                        />
                        <br />
                        <FormControlLabel
                            style={{ marginBottom: 24 }}
                            isCheckBox={true}
                            control={
                                <Checkbox
                                    value="ja"
                                    checked={values.increaseCurrentGasDemand.value.notKnown}
                                    onChange={(event, checked) =>
                                        setValues(values => {
                                            values.increaseCurrentGasDemand.value.notKnown = checked;
                                        })
                                    }
                                />
                            }
                            label="Leistungswert nicht bekannt"
                            error={false}
                        />
                    </Fragment>
                }
            />
        </Fragment>
    );
};
